module.exports = "<span> <div id=login-trigger class=header-trigger> <span>Login</span> </div> <div class=\"login-dropdown header-dropdown\"></div> </span>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./src/scripts/components/loginDropdown/loginDropdown.html
// module id = 45
// module chunks = 0